var map = {
	"./avatar.svg": 7945,
	"./logo-dark.svg": 5250,
	"./logo-light.svg": 7187,
	"./newsletter--dark.svg": 5096,
	"./newsletter--light.svg": 5974,
	"./transit-tool--dark.svg": 4505,
	"./transit-tool--light.svg": 5033,
	"./view-modes": 6420,
	"./view-modes/": 6420,
	"./view-modes/cross": 3050,
	"./view-modes/cross.js": 3050,
	"./view-modes/design": 8009,
	"./view-modes/design.js": 8009,
	"./view-modes/index": 6420,
	"./view-modes/index.js": 6420,
	"./view-modes/normal": 4727,
	"./view-modes/normal.js": 4727,
	"./view-modes/personality": 3471,
	"./view-modes/personality.js": 3471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;